<article class="Snackbar">
	<!-- <ng-container *ngIf="data.hasIcon">
		<span class="Snackbar-icon" [ngSwitch]="data.type">
			<ng-container *ngSwitchCase="ESnackbarType.green">
				<mat-icon class="Icon Icon--svg Icon--svg-little" svgIcon="check-white-icon"> </mat-icon>
			</ng-container>
			<ng-container *ngSwitchCase="ESnackbarType.error">
				<mat-icon class="Icon Icon--svg Icon--svg-little" svgIcon="times-white-icon"> </mat-icon>
			</ng-container>
		</span>
	</ng-container> -->

	<span class="Snackbar__message">{{ data.message }}</span>
</article>

